import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = { class: "design-option-card-title" }
const _hoisted_3 = { class: "plan-card design-option-card" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "plan-info" }
const _hoisted_6 = { class: "design-option-card-dis" }


export default /*@__PURE__*/_defineComponent({
  __name: 'DesignOptions',
  props: {
    designOptions: {},
    selected: {}
  },
  emits: ['update:selected'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.designOptions, (design, idx) => {
      return (_openBlock(), _createElementBlock("div", {
        key: idx,
        class: "design-option-card-group",
        onClick: ($event: any) => (_ctx.$emit('update:selected', idx))
      }, [
        _createElementVNode("h3", _hoisted_2, _toDisplayString(design.title), 1),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("img", {
            src: design.img,
            alt: ""
          }, null, 8, _hoisted_4),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("p", _hoisted_6, _toDisplayString(design.description), 1)
          ])
        ])
      ], 8, _hoisted_1))
    }), 128))
  ]))
}
}

})